<template>
<!--tabbar-->
    <div style="overflow-y: scroll;height: 100vh;">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-list
          v-if="!nodata"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了"
          :offset="30"
          @load="onLoad"
        >
          <van-cell-group
            v-for="(item, index) in list"
            :key="index">
            <van-cell :border="false">
              <template #title>
                <span class="item-time">{{item.create_time | timeFormat}}</span>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-no">
              <template #title>
                <div class="custom-default">
                  <van-row>
                    <van-col span="16">授信金额：{{item.apply_money | pricesFormat('￥')}}</van-col>
                    <van-col span="8" class="right">发起方：{{item.source | sourceToText}}</van-col>
                    <van-col span="24">剩余金额：{{item.surplus_money | pricesFormat('￥')}}</van-col>
                    <van-col span="24">申请备注：{{item.remark}}</van-col>
                    <van-col span="24">审核备注：{{item.handle_remark}}</van-col>
                  </van-row>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-list>
        <van-empty v-else
          class="custom-image"
          :image="require('../../styles/img/nodata.png')"
        />
      </van-pull-refresh>
    </div>
</template>

<script>
export default {
  name: "CreditList",
  data() {
    return {
      status: 2,
      list: [],
      nodata: false, // 是否有数据
      loading: false, // 是否上拉加载
      finished: false, // 上拉加载是否结束即加载全部数据
      isLoading: false, // 是否下拉刷新
      currentPage: 0, //页数
      showCount: 10 ,//每页个数
      totalResult:0,//数据总共条数
    }
  },
  created () {
    // this.onLoad()
  },
  mounted() {
  },
  methods: {
    // 请求数据
    getData () {
      // let status = this.status
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      this.loading = true;
      this.isLoading = false;
      this.finished = false;
      let data = {
        currentPage: this.currentPage, // 当前页数
        showCount: this.showCount, //显示个数
        status: 2 ,//状态，页面默认值2
      };
      this.$api.apis.getCreditInfoList(data).then(res => {
        this.loading = false
        if(res.flag !== '200') {
          this.nodata = true
          return false
        }
        this.totalResult = res.rsObj.page.totalResult
        res.rsObj.page.totalResult > 0 ? (this.nodata = false) : (this.nodata = true)
        this.list = this.list.concat(res.rsObj.list)
        if (this.list.length >= this.totalResult && this.list.length !== 0) {
        	this.finished = true;
        }
        // this.currentPage += 1;
        // if(res&&res.rsObj&&res.rsObj.list&&res.rsObj.list.length>0){
        //   this.list = this.list.concat(res.rsObj.list)
          // 加载状态结束
          // console.log(this.list)
          // if (res.rsObj.list.length === 0||res.rsObj.list.length<this.showCount ) {
          //   this.finished = true
          // }
        // }
        // else{
        //   this.finished = true
        //   this.loading = false
        //   this.isLoading = false
        //   this.nodata = false
        // }
        // this.$toast.clear()
      });
    },
    // 下拉刷新
    onRefresh () {
      this.currentPage = 1;
      this.finished = false;
      this.nodata = false;
      this.list = [];
      this.getData()
      // this.$toast.success('刷新成功')
    },
    onLoad () {
      this.currentPage++
      this.getData();
    },
  },
  filters: {
    sourceToText : (value) => {
      let result = "";
      switch(parseInt(value)){
        case 1:
          result = '平台';
          break;
        case 2:
          result = '货主';
          break;
        default :
          result = ''
          break;
      }
      return result;
    },
    timeFormat : (value) => {
      if(!value) return ''
      let date = new Date(new Date(value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, value.indexOf('.'))).getTime() + 3600 * 1000 * 8)
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let min = date.getMinutes();
      let s = date.getSeconds();
      let result = "";
      return result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
          h < 10 ? "0" + h : h
          }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    },
    pricesFormat : (value,roul) => {
      if(!value) return '--'
      return roul + value
    }
  },
  watch: {}
};
</script>
<style lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/components/List/CreditList.vue